<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/y4wEJi/images/9780310632016_Cover.jpg?1703426647245" alt="This image is the cover for the book Water-Walking"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Water-Walking
      </h1>
      <p class="bookDescription body article font2">
        <p><b>You’re only one step away from the adventure of your life.</b></p><p>In this abridgement of his bestselling book,  <i>If You Want to Walk on Water You Have to</i><i>Get Out of the Boat</i>, John Ortberg invites you to do with God’s help what you could never do on your own—step out of your comfort zone and step out on the risky waters of faith.  If you do, you’ll find that Jesus is waiting to meet you in ways that will change you forever, deepening your character and your trust in God.  The experience is terrifying. It’s thrilling beyond belief. It’s everything you’d expect of someone worthy to be called Lord.  The choice is yours to know him as only a water-walker can, aligning yourself with God’s purpose for your life in the process. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Ortberg
      </h2>
      
      <p class="authorDescription body article"><P>John Ortberg is the senior pastor of Menlo Park Presbyterian Church (MPPC) in the San Francisco Bay Area. His bestselling books include <I>Soul Keeping</I>, <I>Who Is This Man?</I>, and <I>If You Want to Walk on Water, You&rsquo;ve Got to Get Out of the Boat</I>. John teaches around the world at conferences and churches, writes articles for Christianity Today and Leadership Journal, and is on the board of the Dallas Willard Center and Fuller Seminary. He has preached sermons on Abraham Lincoln, The LEGO Movie, and The Gospel According to Les Miserables. John and his wife Nancy enjoy spending time with their three adult children, dog Baxter, and surfing the Pacific. You can follow John on twitter @johnortberg or check out the latest news/blogs on his website at <a href="http://www.johnortberg.com">www.johnortberg.com</a>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsChristianPublishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b467a71